<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Notification]
 * Блок с уведомлением
 */

import { computed } from "vue";

// Types
import type { I_Notification } from "./notification.types";

const props = withDefaults(defineProps<I_Notification>(), {
    type: "warning",
});

// Computed
const classList = computed<string[]>((): string[] => {
    return ["tiw__notification", `tiw__notification__type-${props.type}`];
});
</script>

<template>
    <div v-bind="$attrs" :class="classList">
        <div class="tiw__notification__text">
            <slot />
        </div>
    </div>
</template>

<style lang="scss" src="./notification.scss"></style>
